import React from 'react';
import { Spinner, Alert } from 'react-bootstrap';

interface LoadingStateProps {
    loading: boolean;
    error: string | null;
    children: React.ReactNode;
    loadingMessage?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ 
    loading, 
    error, 
    children, 
    loadingMessage = "Loading..." 
}) => {
    if (error) {
        return (
            <Alert variant="danger">
                <Alert.Heading>Error</Alert.Heading>
                <p>{error}</p>
            </Alert>
        );
    }

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">{loadingMessage}</span>
                </Spinner>
                <span className="ms-2">{loadingMessage}</span>
            </div>
        );
    }

    return <>{children}</>;
};

export default LoadingState;
